import consumer from "./consumer"

// RoomMonitorChannelとのやり取りを行うスクリプト

// ----------------------------------------------------------
// RoomMonitorChannelのsubscribe / unsubscribe
// ----------------------------------------------------------

var room_monitor

// 遷移前がroom_monitorの場合unsubscribe
$(document).on('turbolinks:before-render', () => {
  if (connect_room_channel() && consumer.subscriptions.subscriptions.length >= 1) {
    console.log('room_monitor.unsubscribe')
    room_monitor.unsubscribe()
  }
})

// 遷移後がroom_monitorの場合subscribe
$(document).on('turbolinks:load', () => {
  if (connect_room_channel()) {
    room_monitor = consumer.subscriptions.create({channel: "RoomMonitorChannel", room_id: $('#data-store').data('roomid')},
    {
      connected() {
        // Called when the subscription is ready for use on the server
        console.log('connected.')
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
        console.log('disconnected.')
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        console.log('received.')
        console.dir(data)

        switch (data['type']) {
          case 'status_changed':
            status_changed(data['mid'], data['state'])
            break
          case 'room_condition_changed':
            room_condition_changed(data['rid'], data['state'])
            break
          case 'operation_response':
            operation_response(data['mid'], data['command'], data['result'], data['toast_title'], data['toast_content'])
            break
          case 'control_machine_validation_result':
            control_machine_validation_result(data['validate_result'])
            break
        }
      },

      invoke_control_machine_command(cmd, mid, args) {
        this.perform('control_machine', {'command': cmd, 'mid': mid, 'args': args, 'user_id': $('#data-store').data('user-id')})
      }
    });
  }
})

// roomchannelにつなぐ条件 -> #room-channel#\(room.id)がnullでないこと
function connect_room_channel() {
  var room_id = $('#room-channel').data('roomid')
  if (room_id != null) {
    return true
  }
  else {
    return false
  }
}


// ----------------------------------------------------------
// RoomMonitorChannelへのリクエスト送信
// ----------------------------------------------------------
function invoke_control_machine(cmd, mid) {
  console.log('invoke ' + cmd + ',' + mid)
  var args = {}
  switch (cmd) {
    case 'WriteCharge':
      args = { id: 'charge_amount', mtype: $('#modal-data-store').data('mtype'), amount: $('#charge_amount').val() }
      break
    case 'UpdateCoursePrice':
      args = { id: 'course_price', mtype: $('#modal-data-store').data('mtype'), amount: $('#course_price').val() }
      break
    case 'UpdateDryingTime':
      args = { id: 'course_time', mtype: $('#modal-data-store').data('mtype'), amount: $('#course_time').val() }
      break
    case 'UpdateCoursePrices':
      var prices = []
      $('[id^="course"][id$="_price"]').each((index, elm) => {
        prices.push($(elm).val())
      })
      args = { id: 'course_price', mtype: $('#modal-data-store').data('mtype'), prices: prices, drying_base_time: $('#drying_time').val() }
      break
    case 'ExecuteCourse':
      args = { id: 'execute_course', mtype: $('#modal-data-store').data('mtype'), course_number: $('#execute-course-course-selector').val(), drying_amount: $('#execute-course-duration-selector').val() }
      break
  }
  console.log(`invoke control_machine_command mid : ${mid}`)
  room_monitor.invoke_control_machine_command(cmd, mid, args)
}

// ----------------------------------------------------------
// RoomMonitorChannelからのレスポンス・通知を処理
// ----------------------------------------------------------
function status_changed(mid, state) {
  $.each(state, (key, value) => {
    var id = 'td#m' + mid + '_' + key
    var elm = $(id)
    if (!elm.length) {
      console.log(`skip ${key}`)
      return true
    }
    change_contents(id, elm, value)
  })
}

function room_condition_changed(rid, state) {
  $.each(state, (key, value) => {
    var id = 'dd#r' + rid + '_' + key
    var elm = $(id)
    if (!elm.length) {
      console.log(`skip ${key}`)
      return true
    }
    if (key == 'condition'){
      change_contents(id, elm.children('.room-condition-display'), value)
    } else {
      elm.html(value)
    }
  })
}

function change_contents(id, elm, value) {
  var before = null;
  var after = null;
  if (id.indexOf('course_step_animation') > -1) {
    before = elm.children('img').prop('src')
    after = $(value).prop('src')
  } else {
    before = elm.text()
    after = jQuery('<span/>').html(value).text()
  }

  if (before != after) {
    console.log(`before[${before}] - after[${after}]`)

    elm.html(value)

    if (id.indexOf('course_step_animation') == -1){
      elm.addClass('value-changed')
      elm.delay(1500).queue(() => {
        elm.removeClass('value-changed').dequeue()
      })
    }
  }
}

function operation_response(mid, cmd, result, toast_title, toast_content) {
  console.log(`operation_response - ${mid} ${cmd} ${result}`)
  // Toast Menu
  toastr.options = {
    "positionClass": "toast-bottom-right",
    "timeOut": "60000",
    "extendedTimeOut": "0"
  }
  $('#control-machine-btn').prop('disabled', false)
  switch (result){
    case 'Success':
      toastr.success(toast_content, toast_title)
      break
    case 'Failure':
      toastr.error(toast_content, toast_title)
      break
  }
}

function control_machine_validation_result(validate_result) {
  console.log(`validation_result - ${validate_result['result']}`)

  switch (validate_result['result']) {
    case 'valid':
      $('#machine-control-modal').modal('hide')
      break
    case 'invalid':
      $('#control-machine-btn').prop('disabled', false)
      if ($('.alert')[0]) {
        $('.alert').remove()
      }
      var elements = "<div class=\"alert alert-danger alert-dismissable\" id=\"control-alert\" style=\"\"><a aria-hidden=\"true\" class=\"close\" data-dismiss=\"alert\" data-label=\"close\" href=\"#\">×</a>"
      $(validate_result['messages']).each((index, message) => {
        elements = elements + `<strong>・${message}</strong><br>`
      })
      elements = elements + "</div>"
      $('.modal-header').prepend(elements)
      $(validate_result['failed']).each((index, amount_id) => {
        $('#' + amount_id).css({'border': '1px solid red'})
      })
  }
}

// ----------------------------------------------------------
// イベントハンドラ登録
// ----------------------------------------------------------

$(document).on('confirm:complete', '#control-machine-btn', (e, answer) => {
  // answerが何故か取得できないためe.detail[0]で代用
  if (e.detail[0]) {
    $('#control-machine-btn').prop('disabled', true)
    var mid = $('#modal-data-store').data('mid')
    var cmd = ''
    $('[name="radios"]').each((index, radio) => {
      if (radio.getAttribute('active') == "true") {
        cmd = radio.value
        return false
      }
    })

    invoke_control_machine(cmd, mid)
  }
})

// Formの初期状態(disabled)設定
